export default function faq(){
  const faqlist =  document.querySelectorAll('.site-faq .faqlist dl')
  faqlist.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.target.classList.toggle('active')
    })
  })
}